<template>
    <BaseView>
      <div class="folder-content content-panel">
        <main role="region" title="Archive" aria-label="Archive" class="sessions-panel">
          <h2 class="header">Archive</h2>
          <div v-if="archivedItems.length === 0" class="subheader">
            No sessions or folders have been archived.
          </div>
          <ItemList
            v-else
            ref="archiveItemList"
            :data="archivedItems"
            :columns="columns"
            :loader="loader"
            :openSession="openSession"
            :openFolder="goToFolder"
            :isArchive="true"
            :scrollHeight="'100vh'"
            :lazyLoading="false"
            storageKey="archive-table"
          />
        </main>
      </div>
    </BaseView>
</template>
<script setup lang="ts">
import { ref, useTemplateRef, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import BaseView from "../views/BaseView.vue";
import ItemList from "../components/Home/ItemList.vue";
import { SessionWithOrdersAndType } from "@/types/session-interfaces";
import { ItemListColumn } from "@/types/itemlist-interfaces";
import { Folder } from "@/types/folder-interfaces";


const router = useRouter(),
    store = useStore();

const loader = ref<boolean>(false),
    archiveItemListRef = useTemplateRef("archiveItemList"),
    archiveList = ref();

const columns: ItemListColumn[] = [
{ 
  field: "title", 
  header: "TITLE", 
  sortable: true, 
  width: "30.44%",
},
{
  field: "noteStatus",
  header: "NOTES STATUS",
  sortable: true,
  width: "14.58%",
},
{
  field: "uploads",
  sortable: true,
  sortFunction: (
    session1: SessionWithOrdersAndType,
    session2: SessionWithOrdersAndType
  ) => {
    const uploads1 = session1.uploads || [];
    const uploads2 = session2.uploads || [];
    return uploads1.length - uploads2.length;
  },
  header: "SUPPLEMENTARY FILES",
  width: "18.75%",
},
{
  field: "createdAt",
  header: "CREATED",
  sortable: true,
  width: "17.36%",
},
{ 
  field: "num", 
  header: "", 
  icon: true, 
  width: "18.86%", 
},
];


const openSession = (session: SessionWithOrdersAndType) => {
store.commit("user/setSessionDetails", {
  status: session.noteStatus,
  statusDetail: session.orderStatus,
  order: session.orders,
  ...session,
});
router.push({
  name: "SessionInitializer",
});
};

const goToFolder = (folder: Folder) => {
router.push(`/folder/${folder.id}?title=${folder.title}&isArchived=true`);
};

const archivedItems = computed({
get: () =>  store.getters['itemList/getArchivedItems'],
set: (val) => store.dispatch('itemList/updateArchivedItems', val),
});

const allItems = computed(() => store.getters['itemList/getAllItems']);

import { onMounted } from "vue";

onMounted(() => {
if (allItems.value.length === 0) {
  store.dispatch('itemList/fetchAllData');
}
archiveList.value = archiveItemListRef.value;
});

</script>

<style lang="scss" scoped>
.folder-content {
width: 100%;
height: 100%;
display: flex;
flex-direction: column;
padding: 4rem 5.6rem;
overflow: auto;

.sessions-panel {
  .header {
    @include h2-accent;
  }

  .subheader {
    @include section-sub-header;
    font-size: 1.8rem;
    font-weight: bold;
    text-align: center;
      padding-top: 4rem;
  }
}
}

.v-popper__popper .v-popper__inner {
font-size: 1.2rem;
padding: 12px;
}
</style>